import { render, staticRenderFns } from "./PointWriteComponent.vue?vue&type=template&id=3cde006a&scoped=true&"
import script from "./PointWriteComponent.vue?vue&type=script&lang=js&"
export * from "./PointWriteComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cde006a",
  null
  
)

export default component.exports